import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseButton, LinkButton } from './BaseButton';

const destructiveTertiaryButtonStyle = {
    color: colorSystem.neutral[7],
    '&:hover': {
        background: colorSystem.red[1],
        color: colorSystem.red[7],
    },
    '&:active': {
        background: colorSystem.red[2],
        color: colorSystem.red[8],
    },
    '&:disabled': {
        color: colorSystem.neutral[5],
    },
};

const DestructiveTertiaryButtonHost = styled(BaseButton)(destructiveTertiaryButtonStyle);
const DestructiveTertiaryButtonLinkHost = styled(LinkButton)(destructiveTertiaryButtonStyle);

export const DestructiveTertiaryButton = linkable(DestructiveTertiaryButtonHost, {
    linkHost: DestructiveTertiaryButtonLinkHost,
});
